var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"author"},[_c('a',{attrs:{"href":"https://github.com/D1LL1G4F"}},[_vm._v("Website by Matej Kňazík")])])}]

export { render, staticRenderFns }